// Round Specific Resources used on "Learn More" Pages
<template>
  <v-col class="text-center">
    <h3>Round Specific Resources</h3>
    <v-card class="mx-auto" max-width="400" tile>
      <template v-for="(adversary, idx) in adversaries" :key="adversary.title">
        <router-link :to="adversary.url">
          <v-list-item dense :class="idx % 2 == 0 ? 'c-surface' : 'c-surface--background'" class="text-wrap">
            <v-list-item-title class="c-text--primary">{{adversary.title}}</v-list-item-title>
          </v-list-item>
        </router-link>
      </template>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'Resources',
  data: () => ({
    adversaries: [
      {'title': 'APT3 Overview', 'url': '/enterprise/apt3/' },
      {'title': 'APT29 Overview', 'url': '/enterprise/apt29/' },
      {'title': 'Carbanak+FIN7 Overview', 'url': '/enterprise/carbanak-fin7/' },
      {'title': 'Wizard Spider and Sandworm Overview', 'url': '/enterprise/wizard-spider-sandworm/' },
      {'title': 'Turla Overview', 'url': '/enterprise/turla/' },
    ]
  }),
};
</script>